// extracted by mini-css-extract-plugin
export default {"offer":"styles_offer__PUfKh"};